import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import {
  descargarManual,
  cambiarUrlEncuesta,
  subirArchivoManual,
} from "../functions/Soporte";
import {
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LoaderDialog from "../../ui/loader/Loader";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CustomButton from "../../ui/button/Button";
import CambiarURLReportes from "./modals/CambiarURLReportes";
import ModalSubirArchivo from "../../ui/ModalSubirArchivo";

const ManualesHESQ = ({ API_URL }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [showLoader, setShowLoader] = useState(false);

  const [openCambiarUrl, setOpenCambiarUrl] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState(null);

  const [seguridadPdf, setSeguridadPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const handleChangeURL = async (url) => {
    try {
      setShowLoader(true);
      cambiarUrlEncuesta(API_URL, url);
      setOpenCambiarUrl(false);
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("URL cambiada exitosamente.");
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Ocurrio un error al cambiar la URL.");
    }
  };

  const handleAccordionChange = async (event, isExpanded) => {
    if (isExpanded && !seguridadPdf.fetched && !seguridadPdf.loading) {
      try {
        setSeguridadPdf((prev) => ({ ...prev, loading: true }));
        const blob = await descargarManual(API_URL, "SEGURIDAD");
        const url = URL.createObjectURL(blob);
        setSeguridadPdf({ url, loading: false, fetched: true });
      } catch (error) {
        setSeguridadPdf((prev) => ({ ...prev, loading: false }));
        setSnackbarMessage(`Error al cargar el manual de seguridad`);
        setShowSnackbar(true);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (seguridadPdf.url) URL.revokeObjectURL(seguridadPdf.url.split("#")[0]);
    };
  }, [seguridadPdf.url]);

  const renderPdfContent = (state) => {
    if (state.loading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="600px"
        >
          <CircularProgress />
        </Box>
      );
    }
    if (state.url) {
      return (
        <iframe
          title="Manual"
          src={state.url}
          width="100%"
          height="600px"
          style={{ border: "none" }}
        />
      );
    }
    return null;
  };

  const handleUploadManual = (file) => {
    if (type && file) {
      subirArchivoManual(API_URL, file, type)
        .then((res) => {
          setSnackbarMessage("Archivo subido correctamente");
          setShowSnackbar(true);
        })
        .catch((err) => {
          setSnackbarMessage("Error al subir el archivo");
          setShowSnackbar(true);
        });
    }
  };

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />

      <ModalSubirArchivo
        open={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={handleUploadManual}
        accept={
          type === "SEGURIDAD" ? { "application/pdf": [] } : { "video/*": [] }
        }
      />

      <LoaderDialog open={showLoader} />

      <CambiarURLReportes
        open={openCambiarUrl}
        onClose={() => setOpenCambiarUrl(false)}
        onConfirm={(url) => {
          setOpenCambiarUrl(false);
          handleChangeURL(url);
        }}
      />

      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
          gap: "10px",
        }}
      >
        <h1 className="map-title" style={{ margin: 0 }}>
          Manuales HESQ
        </h1>

        <Accordion onChange={handleAccordionChange}>
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "160px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Manual de Seguridad</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("SEGURIDAD");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(seguridadPdf)}</AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "160px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Video de Seguridad</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("VIDEO_SEGURIDAD");
                  setOpenModal(true);
                }}
              >
                Reemplazar video
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <video
              style={{ width: "50%" }}
              src={`${API_URL}/api/descargar-video-seguridad`}
              controls
              type="video/mp4"
            ></video>
          </AccordionDetails>
        </Accordion>

        <h1 className="map-title" style={{ margin: "10px 0 0 0" }}>
          Reporte de accidentes
        </h1>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#223D51",
              borderColor: "#223D51",
            }}
            variant="outlined"
            href="https://goo.gl/forms/lwdRuox452gwqBU63"
            target="_blank"
            endIcon={<OpenInNewIcon />}
            size="small"
          >
            Reportar un accidente
          </Button>
          <CustomButton
            background={"#223D51"}
            width={"120px"}
            height={"31px"}
            fontSize={"14px"}
            color={"#FFFFFF"}
            text={"Cambiar URL"}
            fontWeight={700}
            fontStyle={"normal"}
            onClick={() => setOpenCambiarUrl(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default ManualesHESQ;
